import { useBundle } from '@amzn/react-arb-tools';
import { RecordType } from '@xbcb/shared-types';
import { getAppRecordMemoConfiguration } from 'libs/appRecordMemoConfiguration';
import { useCurrentUser } from 'libs/hooks';

export const useMemos = (recordType: RecordType) => {
  const { accountType } = useCurrentUser();
  const [recordNameBundle] = useBundle('types.shared.enums.RecordName');
  const configurations =
    getAppRecordMemoConfiguration(recordNameBundle)[recordType] || [];
  const authorizedConfigurations = configurations.filter(
    (config) => !config.blocklist?.includes(accountType),
  );
  return {
    configurations: authorizedConfigurations,
  };
};
